import { jsx as _jsx } from "react/jsx-runtime";
import { CompanyWatermark } from '@streem/ui-react';
export const BrandLogo = ({ logoUrl }) => {
    const handleLogoError = (event) => (event.target.style.display = 'none');
    return (_jsx(CompanyWatermark, { src: logoUrl, onError: handleLogoError, style: { marginRight: '1rem' } }));
};
//# sourceMappingURL=brand_logo.js.map